<!-- 卡片信息 -->
<template>
  <div class="card-list" v-if="dataItem">
    <!-- 猜你想问 -->
    <div v-if="dataItem.type ==='GUESS_WAYBILL'">
      <div> {{ $lang('请问您是否继续咨询该运单') }}：{{ dataItem.content.waybillNo }} </div>
      <div class="p-bottom">
        <span class="p-red">{{ $lang('温馨提示') }}：</span>
        <span class="p-gap">{{ $lang('咨询其他运单请直接输入运单号') }}</span>
      </div>
    </div>
    <template v-else>
      <div class="card-content">
        <div class="card-title">{{ cardOptions[dataItem.type].title }}</div>
        <ul>
          <li v-for="(item, index) in cardOptions[dataItem.type].list" :key="index">
            <span class="content-title">{{ $lang(item.label) }}：</span>
            <span class="content-item">
              <template v-if="item.formatter && typeof item.formatter === 'function'">
                {{ item.formatter(dataItem.content) || '--' }}
              </template>
              <template v-else>
                {{ dataItem.content[item.prop] || '--' }}
              </template>
            </span>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import { cardOptions } from './cardConfig'
export default {
  name: 'CardList',
  props: ['option'],
  created() {
    this.dataItem = this.option.content
  },
  data() {
    return {
      cardOptions,
      dataItem: null
    }
  }
}
</script>

<style lang="scss" scoped>
.card-list {
  display: flex;
  .card-content {
    min-width: 300px;
    max-width: 400px;
    padding: 10px;
    @include bg-color('pop-active');
    border-radius: 5px;
    .card-title {
      font-size: 14px;
      margin-bottom: 10px;
      font-weight: bold;
    }
    ul {
      li {
        display: flex;
        .content-title {
          min-width: 100px;
          font-size: 14px;
          line-height: 20px;
          @include text-color('occupy');
        }
        .content-item {
          flex: 1;
          font-size: 14px;
          @include text-color('subtitle');
          text-align: left;
          line-height: 20px;
        }
      }
    }
  }
}
// 客户
.visitor {
  .card-list {
    .card-content {
      .card-title {
      }
      ul {
        li {
          .content-title {
            text-align: right;
          }
          .content-item {
          }
        }
      }
    }
  }
}

// 坐席
.seats {
  .card-list {
    justify-content: end;
    .card-content {
      .card-title {
        text-align: left;
      }
      ul {
        li {
          display: flex;
          .content-title {
            text-align: right;
          }
          .content-item {
          }
        }
      }
    }
  }
}
</style>
